import React, { useEffect, useState } from 'react';
import Loader from '@/components/Loader';

const CloverCallback = () => {
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        const state = urlParams.get('state');
        const merchant_id = urlParams.get('merchant_id');

        if (error) {
          // OAuth error occurred
          setStatus('error');
          setError(error);
          
          const errorMessage = {
            type: 'CLOVER_OAUTH_ERROR',
            error: error
          };
          
          // Try multiple approaches
          if (window.opener) {
            try { window.opener.postMessage(errorMessage, '*'); } catch (e) {}
          }
          if (window.parent && window.parent !== window) {
            try { window.parent.postMessage(errorMessage, '*'); } catch (e) {}
          }
          if (window.top && window.top !== window) {
            try { window.top.postMessage(errorMessage, '*'); } catch (e) {}
          }
          
          return;
        }

        if (!code || !state) {
          // Missing required parameters
          setStatus('error');
          setError('Missing authorization code or state parameter');
          s
          const errorMessage = {
            type: 'CLOVER_OAUTH_ERROR',
            error: 'Missing authorization code or state parameter'
          };
          
          // Try multiple approaches
          if (window.opener) {
            try { window.opener.postMessage(errorMessage, '*'); } catch (e) {}
          }
          if (window.parent && window.parent !== window) {
            try { window.parent.postMessage(errorMessage, '*'); } catch (e) {}
          }
          if (window.top && window.top !== window) {
            try { window.top.postMessage(errorMessage, '*'); } catch (e) {}
          }
          
          return;
        }

        // Try multiple approaches to send message back to parent
        const message = {
          type: 'CLOVER_OAUTH_SUCCESS',
          code: code,
          state: state,
          merchant_id: merchant_id
        };
        
        // Try multiple approaches
        if (window.opener) {
          try { window.opener.postMessage(message, '*'); } catch (e) {}
        }
        if (window.parent && window.parent !== window) {
          try { window.parent.postMessage(message, '*'); } catch (e) {}
        }
        if (window.top && window.top !== window) {
          try { window.top.postMessage(message, '*'); } catch (e) {}
        }

        setStatus('success');

        // Close the popup after a short delay
        setTimeout(() => {
          window.close();
        }, 1000);

      } catch (err) {
        setStatus('error');
        setError(err.message);
        
        const errorMessage = {
          type: 'CLOVER_OAUTH_ERROR',
          error: err.message
        };
        
        // Try multiple approaches
        if (window.opener) {
          try { window.opener.postMessage(errorMessage, '*'); } catch (e) {}
        }
        if (window.parent && window.parent !== window) {
          try { window.parent.postMessage(errorMessage, '*'); } catch (e) {}
        }
        if (window.top && window.top !== window) {
          try { window.top.postMessage(errorMessage, '*'); } catch (e) {}
        }
      }
    };

    handleOAuthCallback();
  }, []);

  const renderContent = () => {
    switch (status) {
      case 'processing':
        return (
          <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 dark:bg-slate-900">
            <Loader />
            <p className="mt-4 text-slate-600 dark:text-slate-300">
              Completing Clover connection...
            </p>
          </div>
        );

      case 'success':
        return (
          <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 dark:bg-slate-900">
            <div className="mb-4">
              <svg className="w-16 h-16 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-2">
              Successfully Connected!
            </h3>
            <p className="text-slate-600 dark:text-slate-300">
              This window will close automatically.
            </p>
          </div>
        );

      case 'error':
        return (
          <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 dark:bg-slate-900">
            <div className="mb-4">
              <svg className="w-16 h-16 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-2">
              Connection Failed
            </h3>
            <p className="text-slate-600 dark:text-slate-300 mb-4 text-center max-w-md">
              {error || 'An error occurred while connecting to Clover.'}
            </p>
            <button
              onClick={() => window.close()}
              className="px-4 py-2 bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-slate-200 rounded hover:bg-slate-300 dark:hover:bg-slate-600"
            >
              Close Window
            </button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="w-full h-full">
      {renderContent()}
    </div>
  );
};

export default CloverCallback; 